import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { StoresService } from '../services/stores.service';

export const salesModuleActive: CanActivateFn = (route, state): Observable<boolean | UrlTree> | boolean | UrlTree => {
    const storesService = inject(StoresService);
    const slug = state?.root?.firstChild?.params?.slug;

    const router = inject(Router);
    return storesService.getActiveStore(slug).pipe(
        map((store) => {
            if (store?.salesModuleActive) {
                return true;
            } else {
                router.navigate(['/']);
                return false;
            }
        }),
    );
};
